import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Logo from "../images/Logo.png";
import { isUserLoggedIn } from "../service/AuthService";

export default function PublicLayout({ activePage, children }) {
    const navigate = useNavigate();
    // Validity-aware, not just presence: a visitor with a stale token must get
    // the public shell — the authed shell's mount fetches would fail refresh
    // and hard-redirect them off the page (fatal for ad landings).
    const loggedIn = isUserLoggedIn();

    if (loggedIn) {
        return (
            <div className="home-layout">
                <Sidebar activePage={activePage} />
                <main className="home-main">
                    <Header />
                    <div className="home-content">
                        {children}
                    </div>
                </main>
            </div>
        );
    }

    return (
        <div className="faq-page">
            <nav className="landing-nav">
                <div className="landing-nav-inner">
                    <div className="landing-nav-brand" onClick={() => navigate("/")}>
                        <img src={Logo} alt="DeepThought" className="landing-nav-logo theme-invert" />
                        <span className="landing-nav-name">DeepThought</span>
                    </div>
                    <div className="landing-nav-actions">
                        <button className="landing-nav-login" onClick={() => navigate("/login")}>Log In</button>
                        <button className="landing-nav-cta" onClick={() => navigate("/register")}>
                            Get Started <ArrowRight size={14} />
                        </button>
                    </div>
                </div>
            </nav>

            <div className="faq-header" style={{ paddingBottom: 60 }}>
                {children}
            </div>

            <div style={{ flex: 1 }} />

            <footer className="landing-footer">
                <div className="landing-footer-inner">
                    <div className="landing-footer-brand">
                        <img src={Logo} alt="DeepThought" className="landing-nav-logo" />
                        <span className="landing-nav-name">DeepThought</span>
                    </div>
                    <p className="landing-footer-copy">
                        &copy; {new Date().getFullYear()} 42Degrees. All rights reserved.
                    </p>
                    <div className="landing-footer-links">
                        <button className="landing-footer-link" onClick={() => navigate("/about")}>About Us</button>
                        <a href="/whitepaper.pdf" target="_blank" rel="noopener noreferrer" className="landing-footer-link">White Paper</a>
                        <button className="landing-footer-link" onClick={() => navigate("/faq")}>FAQ</button>
                        <button className="landing-footer-link" onClick={() => navigate("/terms")}>Terms</button>
                        <button className="landing-footer-link" onClick={() => navigate("/privacy")}>Privacy</button>
                    </div>
                </div>
            </footer>
        </div>
    );
}
